import React from 'react'
import { Form, Input, message,Button } from 'antd';
import './register.css'
import axios from 'axios'
let second = 60
export default class Register extends React.Component{
    state = {
        timeOut:'获取短信验证码',
        clickAgain:false,
        userinfo:{
            mobile:'',
            code:'',
            password:'',
            confirpsw:''
        },
        inputStatus:'',
        checkStatus:'',
        help:''
    }
    goBack = () => {
        window.history.go(-1)
    }
    handleChange = (which,event) => {
        event.persist()
        if(which === 'phoneNumber'){
            let target = event.target
            this.setState({
                userinfo:Object.assign({},this.state.userinfo,{[target.name]:target.value})
            })
            if(this.checkPhoneNumer(event.target.value)){
                this.setState({
                    checkStatus:'success',
                    inputStatus:true,
                    help:''
                })
            }else{
                this.setState({
                    checkStatus:'error',
                    help:'请输入11位手机号'
                })
            }
        }else{
            let target = event.target
            this.checkPhoneNumer(event.target.value)
            this.setState({
                userinfo:Object.assign({},this.state.userinfo,{[target.name]:target.value})
            })
        }
    }
    updateUserInfo = () => {
        if(!this.state.userinfo.mobile || !this.state.userinfo.code || !this.state.userinfo.password){
            alert('请输入完整信息')
        }else if(this.state.userinfo.password !== this.state.userinfo.confirpsw){
            alert('两次输入密码不一致')
        }else{
            axios.post('/api/admin/user/store/resetPassword ',{
                'phone':this.state.userinfo.mobile,
                'code':this.state.userinfo.code,
                'newPassword':this.state.userinfo.password
            }).then(res=>{
               if(res.status ==200){
                    if(res.data.code == 1000){
                        console.log(res);
                        message.success('修改成功',1,()=>{this.props.history.push('/login')})
                    }else{
                        message.warning(res.data.message,1)
                    }
               }
            }).catch(err=>{
                alert(err)
            })
        }
    }
    getMobileCaptcha = (phoneNumber) => {
        
        axios.post('/api/sms/sendCode',{mobile:phoneNumber}).then(res => {
            console.log(res)
        }).catch(err => {
            console.log(err)
        })
    }
    getMsgCaptcha = () => {
        if(!this.state.userinfo.mobile){
            alert('请输入手机号')
            return 
        }
        this.setState({clickAgain:true},()=>{
            this.getMobileCaptcha(this.state.userinfo.mobile)
            if(this.state.clickAgain){
                let interval = setInterval(() => {
                    this.setState({
                        timeOut:`${second--}秒后从新发送`
                    },()=>{
                        if(second<0){
                            this.setState({
                                clickAgain:false,
                                timeOut:'获取短信验证码',
                            })
                            clearInterval(interval)
                            second = 60
                        }   
                    })
                    console.log('*******')
                }, 1000);
            }
        })
        
    }
    //手机号验证
    checkPhoneNumer = (phoneNumber) => {
        let regular = /^1\d{10}$/
        return regular.test(phoneNumber)
    }
    componentDidMount(){
        
    }
    render(){
        const formItemLayout = {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 6 },
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 18 },
            },
          };
          const tailFormItemLayout = {
            wrapperCol: {
              xs: {
                span: 24,
                offset: 0,
              },
              sm: {
                span: 18,
                offset: 6,
              },
            },
          };
        return(
            <div className='registerContainer' style={{backgroundSize: 'cover'}}>
                <div className="loginBox">
                    <div className='formContainer'>
                        <div className="title">
                            <span>找回密码</span>
                        </div>
                        <Form onSubmit={this.handleSubmit}>
                            <Form.Item required {...formItemLayout} help={this.state.help} validateStatus={this.state.checkStatus} hasFeedback={this.state.inputStatus} label="用户手机号">
                                <Input onChange={this.handleChange.bind(this,'phoneNumber')} name="mobile" value={this.state.userinfo.mobile}/>
                            </Form.Item>
                            <Form.Item required {...formItemLayout} label="手机验证码">
                                <Input onChange={this.handleChange.bind(this,'code')} name="code" value={this.state.userinfo.code} />
                                <button disabled={this.state.clickAgain} onClick={this.getMsgCaptcha} className='msgBtn'>{this.state.timeOut}</button>
                            </Form.Item>
                            <Form.Item required {...formItemLayout} label="输入新密码">
                                <Input type="password" onChange={this.handleChange.bind(this,'psw')} name="password" value={this.state.userinfo.password} />
                            </Form.Item>
                            <Form.Item required {...formItemLayout} label="确认新密码">
                                <Input type="password" onChange={this.handleChange.bind(this,'confirpsw')} name="confirpsw" value={this.state.userinfo.confirpsw} />
                            </Form.Item>
                            <Form.Item required {...tailFormItemLayout}>
                                <div className='btn-container'>
                                    <Button type='primary' onClick={this.updateUserInfo} style={{marginRight:10}}>确认修改</Button>
                                    <Button onClick={this.goBack}><span style={{visibility:'hidden'}}>我</span>返回<span style={{visibility:'hidden'}}>我</span></Button>
                                </div>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        )
    }
}
